import { render, staticRenderFns } from "./DataViewSmall.vue?vue&type=template&id=5deaf432"
import script from "./DataViewSmall.vue?vue&type=script&lang=js"
export * from "./DataViewSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports